"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarningTimeout = void 0;
const features_1 = require("../../features");
const tracker_1 = require("../../tracker");
const translations_1 = require("../../translations");
const useWarningTimeout = (props) => {
    return (0, features_1.useWarningTimeout)({ ...props, tracker: tracker_1.tracker, translate: translations_1.translate });
};
exports.useWarningTimeout = useWarningTimeout;
//# sourceMappingURL=useWarningTimeout.js.map